import React from "react";
import { createRoot } from "react-dom/client";
import {BrowserRouter as Router} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Router>
    <App />
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
